import * as React from 'react';
import ReactPlayer from 'react-player';
import { Helper } from '../../../Helper';
import { Environment } from '../../../services/Environment';
import { IEnvironment } from '../../../interfaces/IEnvironment';
import { IAButton } from '../../button/Button';
import * as styles from "./MediaSelectorPreview.css";
import { LocalizationService } from '../../../services/LocalizationService';
import { IASkeleton } from '../../skeleton/Skeleton';
import { ICropSetting } from '../../../interfaces/ICropSetting';

export interface IAMediaSelectorPreviewProps {
  token: string;
  tenant: string;
  environment: IEnvironment;
  fileType: "image" | "video";
  highlightColor: string;
  url: string;
  style?: React.CSSProperties;
  imageCrop?: ICropSetting;
  onClearImage: () => void;
}

export interface IAMediaSelectorPreviewState {
  isLoading: boolean;
  hasError: boolean;
}

export class IAMediaSelectorPreview extends React.Component<IAMediaSelectorPreviewProps, IAMediaSelectorPreviewState> {
  private readonly localizationService = new LocalizationService();
  
  constructor(props: IAMediaSelectorPreviewProps) {
    super(props);
    this.state = {
      isLoading: true,
      hasError: false
    };
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public render(): JSX.Element {
    const style = this.props.style ?? {};
    const isBlob = this.props.url.startsWith("blob:");
    return (
      <div
        className={styles.IA_MediaSelectorPreviewContainer}
        style={style}
      >
        {!this.state.isLoading && this.props.onClearImage &&
          <IAButton
            label="Clear image"
            icon="Trash"
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              padding: "0 10px"
            }}
            buttonColor="rgba(0,0,0,.3)"
            mouseOverButtonColor="rgba(0,0,0,.2)"
            borderRadius={5}
            onClick={() => this.props.onClearImage()}
          />
        }
        {this.props.fileType === "image"
        ? 
          <img
            className={styles.IA_MediaSelectorPreviewImage}
            style={{
              opacity: this.state.isLoading ? 0 : 1,
              display: this.state.hasError ? "none" : undefined,
              position: this.state.isLoading ? "absolute" : undefined
            }}
            src={isBlob ? this.props.url : Helper.getImageFromApiWhenOutsideSharepoint(Environment.getEnvironmentForImageAPI(this.props.environment), this.props.tenant, this.props.token, this.props.url, "", "Full", this.props.imageCrop, true, !!!this.props.imageCrop)}
            onLoad={() => this.setState({isLoading: false, hasError: false})}
            onError={() => this.setState({isLoading: false, hasError: true})}
          />
        :
          <ReactPlayer
            style={{
              opacity: this.state.isLoading ? 0 : 1,
              display: this.state.hasError ? "none" : undefined,
              position: this.state.isLoading ? "absolute" : undefined,
              borderRadius: 5
            }}
            width="100%"
            url={isBlob ? this.props.url : Helper.getVideoUrl(Environment.getEnvironmentForImageAPI(this.props.environment), this.props.tenant, this.props.token, this.props.url)}
            pip={false}
            onReady={() => this.setState({isLoading: false, hasError: false})}
            onError={() => this.setState({isLoading: false, hasError: true})}
          />
        }
        {this.state.isLoading &&
          <div
            style={{
              width: "100%",
              aspectRatio: "16 / 9"
            }}
          >
            <IASkeleton
              skeleton={{
                height: "100%",
                width: "100%",
                borderRadius: 5
              }}
            />
          </div>
        }
        {this.state.hasError && <p className={styles.IA_MediaSelectorPreviewErrorText}>{this.localizationService.strings.MediaSelector_ErrorLoadingPreview}</p>}
      </div>
    );
  }
}
